// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  visibleUnitId: __t.string().name("visible_unit_id"),
  playerId: __t.string().name("player_id"),
  matchId: __t.string().name("match_id"),
  unitId: __t.string().name("unit_id"),
  armyIndex: __t.u32().name("army_index"),
  persistentId: __t.option(__t.string()).name("persistent_id"),
  archetype: __t.string(),
  name: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  facing: __t.f64(),
  state: __t.string(),
  stance: __t.string(),
  strength: __t.f64(),
  maxStrength: __t.f64().name("max_strength"),
  isGeneral: __t.bool().name("is_general"),
  category: __t.string(),
  symbol: __t.string(),
  level: __t.u32(),
  isRanged: __t.bool().name("is_ranged"),
  suppressed: __t.bool(),
  followMode: __t.bool().name("follow_mode"),
  garrisonedIn: __t.option(__t.u32()).name("garrisoned_in"),
  ammo: __t.option(__t.u32()),
  maxAmmo: __t.option(__t.u32()).name("max_ammo"),
  fireRange: __t.option(__t.f64()).name("fire_range"),
  rangedStance: __t.option(__t.string()).name("ranged_stance"),
  morale: __t.f64(),
  maxMorale: __t.f64().name("max_morale"),
  fatigue: __t.f64(),
  reinforcedSides: __t.u32().name("reinforced_sides"),
  chainFrontUnitId: __t.option(__t.string()).name("chain_front_unit_id"),
  chainRearUnitId: __t.option(__t.string()).name("chain_rear_unit_id"),
  chainDepth: __t.u32().name("chain_depth"),
  chainSize: __t.u32().name("chain_size"),
  hasPendingOrder: __t.bool().name("has_pending_order"),
  currentOrderType: __t.option(__t.string()).name("current_order_type"),
  experience: __t.u32(),
  idleStance: __t.string().name("idle_stance"),
  guardPointX: __t.option(__t.f64()).name("guard_point_x"),
  guardPointY: __t.option(__t.f64()).name("guard_point_y"),
  guardRadius: __t.f64().name("guard_radius"),
  visionRange: __t.f64().name("vision_range"),
  moveTargetX: __t.option(__t.f64()).name("move_target_x"),
  moveTargetY: __t.option(__t.f64()).name("move_target_y"),
  moveTargetFacing: __t.option(__t.f64()).name("move_target_facing"),
  fireAtWill: __t.option(__t.bool()).name("fire_at_will"),
  formationShape: __t.option(__t.string()).name("formation_shape"),
  length: __t.f64(),
  width: __t.f64(),
  troopsAlive: __t.u32().name("troops_alive"),
  troopsMax: __t.u32().name("troops_max"),
  builderEnabled: __t.bool().name("builder_enabled"),
  squadId: __t.option(__t.string()).name("squad_id"),
  squadSize: __t.u32().name("squad_size"),
  isCaptain: __t.bool().name("is_captain"),
  captainUnitId: __t.option(__t.string()).name("captain_unit_id"),
  kills: __t.u32(),
  xpEarned: __t.u32().name("xp_earned"),
});
